import { render, staticRenderFns } from "./BuyXGetYRule.vue?vue&type=template&id=abf734e2&scoped=true"
import script from "./BuyXGetYRule.vue?vue&type=script&lang=js"
export * from "./BuyXGetYRule.vue?vue&type=script&lang=js"
import style0 from "./BuyXGetYRule.vue?vue&type=style&index=0&id=abf734e2&prod&scoped=true&lang=css"
import style1 from "./BuyXGetYRule.vue?vue&type=style&index=1&id=abf734e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf734e2",
  null
  
)

export default component.exports